import Vue, { reactive } from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import axios from 'axios';
import { Toast } from "vant";

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    children: [
      {
        path: "/homes",
        name: "homes",
        component: () => import("../views/tabble/homes.vue"),
      },

      {
        path: "/service",
        name: "service",
        component: () => import("../views/tabble/service.vue")
      },
      {
        path: "/Posthouse",
        name: "Posthouse",
        component: () => import("../views/tabble/Posthouse.vue")
      },
      {
        path: "/me",
        name: "me",
        component: () => import("../views/tabble/me.vue")
      },

    ]
  },


  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },

  {
    path: '/Personal',
    name: 'Personal',
    component: () => import('../views/list/Personal.vue')
  },
  {
    path: '/Archives',
    name: 'Archives',
    component: () => import('../views/list/Archives.vue')
  },




  {
    path: '/Maps',
    name: 'Maps',
    component: () => import('../views/list/Maps.vue')
  },
  {
    path: '/AnswerProblem',
    name: 'AnswerProblem',
    component: () => import('../views/list/AnswerProblem.vue')
  },
  {
    path: '/AnswerReply',
    name: 'AnswerReply',
    component: () => import('../views/list/AnswerReply.vue')
  },
  {
    path: '/AnswerDetail',
    name: 'AnswerDetail',
    component: () => import('../views/list/AnswerDetail.vue')
  },
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login/Login.vue')
  },

  {
    path: '/Sign',
    name: 'Sign',
    component: () => import('../views/Login/Sign.vue')
  },
  {
    path: '/Update',
    name: 'Update',
    component: () => import('../views/Login/Update.vue')
  },
  {
    path: '/Verify',
    name: 'Verify',
    component: () => import('../views/Login/Verify.vue')
  },


  {
    path: '/sousuo',
    name: 'sousuo',
    component: () => import('../views/list/sousuo.vue')
  },
  {
    path: '/before/:id',
    name: '/before',
    component: () => import('../views/list/before.vue')
  },
  {
    path: '/Sleep',
    name: 'Sleep',
    component: () => import('../views/list/Sleep.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/list/search.vue')
  },
  {
    path: '/ConsultDetail',
    name: 'ConsultDetail',
    component: () => import('../views/list/ConsultDetail.vue')
  },

  {
    path: '/detection',
    name: 'Detection',
    component: () => import('../views/list/Detection.vue')
  },

  {
    path: '/fwdynamic',
    name: 'fwdynamic',
    component: () => import('../views/list/fwdynamic.vue')
  },
  {
    path: '/lettres',
    name: 'lettres',
    component: () => import('../views/list/lettres.vue')
  },
  {
    path: '/zxDetails',
    name: 'zxDetails',
    component: () => import('../views/list/zxDetails.vue')
  },
  {
    path: '/goconsulting',
    name: 'goconsulting',
    component: () => import('../views/list/goconsulting.vue')
  },
  {
    path: '/Horizon',
    name: 'Horizon',
    component: () => import('../views/list/Horizon.vue')
  },
  {
    path: '/Psychological',
    name: 'Psychological',
    component: () => import('../views/list/Psychological.vue')
  },
  {
    path: '/Psychologicalclass',
    name: 'Psychologicalclass',
    component: () => import('../views/list/Psychologicalclass.vue')
  },
  {
    path: '/soul',
    name: 'soul',
    component: () => import('../views/list/soul.vue')
  },
  { path: '/detail/:id', name: 'detail', component: () => import('../views/Home/Detail.vue') },
  {
    path: '/bannerDetail',
    name: 'bannerDetail',
    component: () => import('../views/Home/BannerDetail.vue')
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('../views/Home/Notice.vue')
  },
  {
    path: '/notice1',
    name: 'notice1',
    component: () => import('../views/Home/Notice1.vue')
  },
  { path: '/activity', name: 'activity', component: () => import('../views/Activity/Activity.vue') },
  { path: '/activityRule', name: 'activityRule', component: () => import('../views/Activity/ActivityRule.vue') },
  { path: '/receiveAddress', name: 'receiveAddress', component: () => import('../views/Activity/ReceiveAddress.vue') },
  { path: '/answer', name: 'answer', component: () => import('../views/Activity/Answer.vue') },

]

function getPsychicInfo() {
  //获取齐鲁工惠信息
  return new Promise(function (resolve, reject) {
    labor.getLaborStatus(function (res) {
      if (res.laborStatus == "" || res.laborStatus == 0) {
        //代表齐鲁工惠App未注册认证会员
        reject("/forbidden");
      } else {
        labor.getUserInfo(function (obj) {
          // alert(JSON.stringify(obj))
          //非齐鲁工惠进入
          if (obj.error == "no data") {
            reject("/login");
          } else {
            let user = new Object();
            user.sex = obj.sex;
            user.userPhone = obj.userPhone;
            //后台userName相当于phone做处理了
            window.localStorage.setItem("userName", user.userPhone);
            window.localStorage.setItem("nickName", user.fullName);
            user.userIcon = obj.userIcon;
            user.districtCodeLocation = obj.districtCodeLocation;
            user.laborName = obj.laborName;
            user.laborId = obj.laborId;
            user.fullName = obj.fullName;
            user.birthday = obj.birthday;
            let districtCode = obj.districtCode;
            if (districtCode) {
              user.districtCode = districtCode.substring(0, 4);
            } else {
              user.districtCode = obj.laborCode.substring(0, 4);
            }
            user.laborCode = obj.laborCode;
            user.phone = obj.userPhone;
            user.userSex = user.sex;
            let reg = /\d{11}$/;
            if (!reg.test(obj.userPhone)) {
              Toast.fail("登录失败,请稍后重试！");
            } else {
              sessionStorage.setItem("userInfo", JSON.stringify(user))
              resolve(user);
            }
          }
        });
      }
    });
  })
}

function login(userInfo) {
  return new Promise(function (resolve, reject) {
    axios.post("/api/login/qlgh", userInfo)
      .then((ress) => {
        if (ress.data.token) {
          let token = ress.data.token;
          window.localStorage.setItem("user", token);
          let userId = ress.data.userId;
          window.localStorage.setItem("userId", userId);
          resolve(ress)
        }
      })
      .catch(() => {
        reject()
      })
  })
}

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.log('222222222222',to)
  if (to.query.isMini) window.localStorage.setItem('isMini', 'isMini')
  if (to.query.soulId) window.localStorage.setItem('soulId', to.query.soulId)
  var currentToken = window.localStorage.getItem("user");// 获取token信息
  var isApp = labor.isApp();//是否是从齐鲁工会打开
  if (!currentToken) {
    if (isApp) {
      window.localStorage.removeItem('isMini')
      let users = JSON.parse(sessionStorage.getItem("userInfo"));
      if (users) {
        login(users).then((res) => {
          if (to.path == '/') {
            next('/homes')
          } else {
            next()
          }
        }).catch(() => {
          Toast.fail("登录失败")
        })
      } else {
        getPsychicInfo().then((res) => {
          let user = res;
          login(user).then(() => {
            if (to.path == '/') {
              next('/homes')
            } else {
              next()
            }
          }).catch(() => {
            Toast.fail("登录失败")
          })
        }).catch((err) => {
          next(err)
        })
      }
    } else {
      next()
    }
  } else {
    if (to.path == '/') {
      next('/homes')
    } else {
      next()
    }
  }
})


export default router
